var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bem-button',{attrs:{"block":"de-icon","type":_vm.type,"color":"accent-1","size":"md"},on:{"event":function($event){return _vm.$emit('action', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }